import type { Country } from '@seek/melways-sites';

export const getLanguageSwitcher = (
  country: Country | null,
  pathname: string,
) => {
  const queryParams =
    typeof window !== 'undefined' ? window.location.search : '';
  return country === 'id' || country === 'th'
    ? {
        en: {
          url: `${pathname.replace(`/${country}`, '')}${queryParams}`,
        },
        [country]: {
          url: `/${country}${pathname}${queryParams}`,
        },
      }
    : undefined;
};
